import React, { useEffect, useState } from "react";
import { v1 as uuidv1 } from "uuid";

import { capitalizeCategory } from "../utils/utils";
import { CATDATA, STAGDATA } from "../utils/initData";

const Manage = () => {
  const [speeches, setSpeeches] = useState([]);
  const [categories, setCategories] = useState([]);

  const [currentCategoryName, setCurrentCategoryName] = useState("default");
  const [categoryInput, setCategoryInput] = useState("");
  const [speechInput, setSpeechInput] = useState("");
  const [isCategories, setIsCategories] = useState(true);

  const [currentCategory, setCurrentCategory] = useState("0");
  const [isEditingCategory, setIsEditingCategory] = useState(false);

  const [currentSpeech, setCurrentSpeech] = useState();
  const [isEditingSpeech, setIsEditingSpeech] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("speeches") !== null) {
      setSpeeches(JSON.parse(localStorage.getItem("speeches")));
    } else {
      setSpeeches(STAGDATA);
      localStorage.setItem("speeches", JSON.stringify(STAGDATA));
    }

    if (localStorage.getItem("categories") !== null) {
      setCategories(JSON.parse(localStorage.getItem("categories")));
    } else {
      setCategories(CATDATA);
      localStorage.setItem("categories", JSON.stringify(CATDATA));
    }
  }, []);

  const addCategoryHandler = (e) => {
    e.preventDefault();

    if (isEditingCategory) {
      const catToEdit = categories.find((cat) => cat.id === currentCategory);
      const categoryToUpdate = catToEdit.category;

      catToEdit.category = categoryInput;

      const toSpliceIndex = categories.findIndex(
        (cat) => cat.id === currentCategory
      );

      const catsToSplice = [...categories];

      catsToSplice.splice(toSpliceIndex, 1, catToEdit);

      const updatedCategories = [...catsToSplice];

      setCategories(updatedCategories);

      localStorage.setItem("categories", JSON.stringify(updatedCategories));

      const updatedSpeeches = speeches.map((spc) => {
        if (spc.category === categoryToUpdate) {
          return {
            ...spc,
            category: categoryInput,
          };
        }

        return spc;
      });

      setSpeeches([...updatedSpeeches]);
      localStorage.setItem("speeches", JSON.stringify(updatedSpeeches));

      setIsEditingCategory(false);
    } else {
      const newCategory = {
        category: categoryInput,
        id: uuidv1(),
      };

      const updatedCategories = [...categories, newCategory];

      setCategories(updatedCategories);

      localStorage.setItem("categories", JSON.stringify(updatedCategories));
    }

    setCategoryInput("");
  };

  const addSpeechHandler = (e) => {
    e.preventDefault();

    // console.log(speechInput, "addspeech");

    if (isEditingSpeech) {
      const spcToEdit = speeches.find((spc) => spc.id === currentSpeech);

      spcToEdit.text = speechInput;

      const toSpliceIndex = speeches.findIndex(
        (spc) => spc.id === currentSpeech
      );

      const spcsToSplice = [...speeches];

      spcsToSplice.splice(toSpliceIndex, 1, spcToEdit);

      const updatedSpeeches = [...spcsToSplice];

      setCategories(updatedSpeeches);

      localStorage.setItem("speeches", JSON.stringify(updatedSpeeches));

      setIsEditingSpeech(false);
    } else {
      const newSpeech = {
        category: currentCategoryName,
        text: speechInput,
        id: uuidv1(),
      };

      const updatedSpeeches = [...speeches, newSpeech];

      setSpeeches(updatedSpeeches);

      localStorage.setItem("speeches", JSON.stringify(updatedSpeeches));
    }

    setSpeechInput("");
  };

  const changeCategory = (catId) => {
    const ncat = categories.find((cat) => cat.id === catId);
    setCurrentCategory(ncat.id);
    setCurrentCategoryName(ncat.category);

    cancelEditHandler();
  };

  const changeManagingItems = (b) => {
    setIsCategories(b);
  };

  const editCategoryStart = (e) => {
    const catToEdit = categories.find((cat) => cat.id === currentCategory);

    setIsEditingCategory(true);
    setCategoryInput(catToEdit.category);
  };

  const editSpeechStart = (e) => {
    // console.log("----->", e);

    const spcToEdit = speeches.find((spc) => spc.id === e);

    setCurrentSpeech(e);

    setIsEditingSpeech(true);
    setSpeechInput(spcToEdit.text);
  };

  const cancelEditHandler = () => {
    setIsEditingCategory(false);
    setIsEditingSpeech(false);
    setCurrentSpeech(null);
    setCategoryInput("");
    setSpeechInput("");
  };

  const deleteSpeechStart = (e, id) => {
    e.stopPropagation();

    const d = window.confirm("Are you sure to delete this speech?");

    if (d) {
      const toSpliceIndex = speeches.findIndex((spc) => spc.id === id);

      const spcsToSplice = [...speeches];

      spcsToSplice.splice(toSpliceIndex, 1);

      const updatedSpeeches = [...spcsToSplice];

      setSpeeches(updatedSpeeches);

      localStorage.setItem("speeches", JSON.stringify(updatedSpeeches));
    }

    return;
  };

  const deleteCategoryStart = (e) => {
    const d = window.confirm("Are you sure to delete this category?");

    if (d) {
      const toSpliceIndex = categories.findIndex(
        (cat) => cat.id === currentCategory
      );
      const catToDelete = categories.find((cat) => cat.id === currentCategory);

      const catsToSplice = [...categories];

      catsToSplice.splice(toSpliceIndex, 1);

      const updatedCategories = [...catsToSplice];

      setCategories(updatedCategories);

      const updatedSpeeches = speeches.filter(
        (spc) => spc.category !== catToDelete.category
      );

      setSpeeches([...updatedSpeeches]);
      localStorage.setItem("speeches", JSON.stringify(updatedSpeeches));

      localStorage.setItem("categories", JSON.stringify(updatedCategories));
    }
  };

  return (
    <div className="container">
      <div className="selectors">
        <button onClick={(e) => changeManagingItems(true)}>
          Manage Categories
        </button>
        <button onClick={(e) => changeManagingItems(false)}>
          Manage Speeches
        </button>
      </div>
      {isCategories && (
        <section className="category-select">
          <form onSubmit={(e) => addCategoryHandler(e)}>
            <label htmlFor="category">Add a category</label>
            <input
              type="text"
              id="category"
              name="category"
              value={categoryInput}
              onChange={(e) => setCategoryInput(e.target.value)}
            />
            <button type="submit">
              {!isEditingCategory ? (
                <i className="far fa-plus-square"></i>
              ) : (
                <i className="far fa-edit"></i>
              )}
            </button>
          </form>
          {isEditingCategory && (
            <button
              className="cancel-edit"
              onClick={(e) => cancelEditHandler()}
            >
              Cancel Edit
            </button>
          )}
          <select
            className="manage"
            id="voices"
            value={currentCategory}
            onChange={(e) => changeCategory(e.target.value)}
          >
            {categories.map((category, key) => {
              return (
                <option key={key} value={category.id}>
                  {capitalizeCategory(category.category)}
                </option>
              );
            })}
          </select>
          {currentCategory !== "0" && (
            <div className="selectors">
              <button onClick={(e) => editCategoryStart()}>
                <i className="far fa-edit"></i> Edit Category
              </button>
              <button onClick={(e) => deleteCategoryStart()}>
                <i className="far fa-minus-square"></i> Delete Category
              </button>
            </div>
          )}
        </section>
      )}
      {!isCategories && (
        <section className="speech-list">
          <select
            className="manage"
            id="voices"
            value={currentCategory}
            onChange={(e) => changeCategory(e.target.value)}
          >
            {categories.map((category, key) => {
              return (
                <option key={key} value={category.id}>
                  {capitalizeCategory(category.category)}
                </option>
              );
            })}
          </select>
          <form onSubmit={(e) => addSpeechHandler(e)}>
            <label htmlFor="speech">
              Add a speech to the selected category.
            </label>
            <input
              type="text"
              id="speech"
              name="speech"
              value={speechInput}
              onChange={(e) => setSpeechInput(e.target.value)}
            />
            <button type="submit">
              {!isEditingSpeech ? (
                <i className="far fa-plus-square"></i>
              ) : (
                <i className="far fa-edit"></i>
              )}
            </button>
          </form>
          {isEditingSpeech && (
            <button
              className="cancel-edit"
              onClick={(e) => cancelEditHandler()}
            >
              Cancel Edit
            </button>
          )}
          <div>
            {speeches
              .filter((text) => text.category === currentCategoryName)
              .map((text, key) => {
                return (
                  <div
                    className="text-item"
                    key={key}
                    onClick={(e) => editSpeechStart(text.id)}
                  >
                    <p>{text.text}</p>
                    <i
                      onClick={(e) => deleteSpeechStart(e, text.id)}
                      className="delete-btn far fa-minus-square"
                    ></i>
                  </div>
                );
              })}
          </div>
        </section>
      )}
    </div>
  );
};

export default Manage;
